module.exports = __webpack_public_path__ + "img/snapchat-logo.97eb299.svg";